<template>
    <CCard
        v-if="!item.ad"
        :style="cardStyle(item)"
    >
        <CCardBody>
            <CRow>
                <div class="col-sm-4" style="text-align: center">
                    <img src="@/assets/images/logo_nomina.png" width="150" />
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-12" v-for="type in item.type_vehicle" :key="type.id">
                        </div>
                        <div class="col-12">
                            <label class="label-detail">
                                Folio: &nbsp; {{item.id}}
                            </label>
                        </div>
                        <div class="col-12" v-if="hasStateName">
                            <label class="label-detail">
                                En: &nbsp; {{itemStateName}}
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="item.is_demo" class="col-sm-2" style="text-align: center">
                    <img src="@/assets/images/ic_star.png" width="60" />
                </div>
                <a class="col-sm-12">
                    <div class="btn-detail" @click="onShowItem(item)"> 
                        {{ $t('directories.detail') }}
                    </div>
                </a>
            </CRow>
        </CCardBody>
    </CCard>
    <CCard v-else>
        <CCardBody>
            <a :href="item.advertisement.url" target="_blank" rel="noopener noreferrer">
                <img :src="item.advertisement.path" style="height: 100%; width: 100%; object-fit: cover;"/>
            </a>
        </CCardBody>
    </CCard>
</template>

<script>
import store from '../../../store'

export default {
    name: "ChargeItem",
    props: ['item'],
    computed: {
        itemStateName() {
            let self = this;
            return (self.item != undefined && self.item.state != null) ? self.item.state.name : "";
        },
        hasStateName() {
            return this.itemStateName.trim().length > 0;
        },
        backgroundColor() {
            let self = this;

            if (self.item.is_demo && store.state.configuration != null 
                && store.state.configuration.configuration.color_activas != null) {
                return "#"+store.state.configuration.configuration.color_activas;
            } else {
                return self.item.type_vehicle.color;
            }
        }
    },
    methods: {
        cardStyle(currentitem) {
            const createdDate = new Date(currentitem.created_at);
            const diffDays = (Date.now() - createdDate.getTime()) / 86400000;

            return {
                backgroundColor: diffDays < 8 ? '#000000' : '#DCEDC8',
                color: diffDays < 8 ? '#FFFFFF' : '#000000'
            };
        },
        onShowItem() {
            this.$emit('onShowItem', this.item);
        }
    }
}
</script>

<style scoped>
    .label {
        color: black;
    }
    .label-detail {
        color: inherit;
    }
</style>
